"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _alloyReactNotification = require("@adsk/alloy-react-notification");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _i18n = require("../../../i18n");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useNotifications = () => {
  const {
    showNotification
  } = (0, _alloyReactNotification.useNotifications)();
  const {
    T
  } = (0, _i18n.useTranslation)();
  return {
    notifySuccess: getNotifySuccess({
      showNotification,
      T
    }),
    notifyError: getNotifyError({
      showNotification,
      T
    })
  };
};
const getNotifySuccess = _ref => {
  let {
    showNotification,
    T
  } = _ref;
  return _ref2 => {
    let {
      i18nKey,
      values
    } = _ref2;
    return showNotification({
      message: T.translate(i18nKey, values),
      status: _alloyReactNotification.NOTIFICATION_STATUSES.SUCCESS,
      style: _alloyReactTheme.default.typography.bodyMedium
    });
  };
};
const getNotifyError = _ref3 => {
  let {
    showNotification,
    T
  } = _ref3;
  return _ref4 => {
    let {
      i18nKey,
      values
    } = _ref4;
    return showNotification({
      message: T.translate(i18nKey, values),
      status: _alloyReactNotification.NOTIFICATION_STATUSES.ERROR,
      style: _alloyReactTheme.default.typography.bodyMedium
    });
  };
};
var _default = exports.default = useNotifications;